import React from 'react';

import { RCIcon, RCButton } from '../';
import { ButtonElementProps } from '../RCButton/RCButton';

/* eslint-disable react/require-default-props */
interface RCIconButtonProps extends ButtonElementProps {
  /**
   * Import the SVG with `?component` in the import path, and pass it through here.
   */
  svgComponent: (props: React.SVGProps<SVGElement>) => React.ReactElement;

  /** A short description of the button's action, generally 1-2 words. Rendered in a tooltip and in the 'aria-label' attribute. */
  label: string;

  hideTooltip?: boolean;
}

/* eslint-enable react/require-default-props */

/**
 * Combines `RCIcon` and `RCButton` into a fully accessible component.
 * Use whenever you need a clickable icon, with the exception of a close button - we have `RCCloseButton` for that specific case.
*/
export const RCIconButton = React.forwardRef<HTMLButtonElement, RCIconButtonProps>(
  function RCIconButton({
    svgComponent,
    label,
    variant = 'transparent',
    size = 'medium',
    isSubmit = false,
    hideTooltip = false,
    ...passthroughProps
  }: RCIconButtonProps, ref) {

    return (
      <div className="rc-icon-button">
        <RCButton
          ref={ref}
          {...(passthroughProps as ButtonElementProps)}
          iconOnly={<RCIcon svgComponent={svgComponent} />}
          iconLabel={label}
          hideTooltip={hideTooltip}
          variant={variant}
          size={size}
          isSubmit={isSubmit}
        />
      </div>
    );
  },
);
